
import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router, NavigationEnd } from '@angular/router';

import { McBreadcrumbsModule } from 'ngx-breadcrumbs-ui';
import {AuthenticationGuard} from "./shared/core-jpats/services/authentication.guard";
import {UnauthorizedComponent} from "./components/unauthorized/unauthorized.component";
import {AuthorizedComponent} from "./login/authorized/authorized.component";
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';

import {PatientsHomeComponent} from "./patients/patients-home/patients-home.component";
import {LoggedoutComponent} from "./login/loggedout/loggedout.component";
import {FileuploadComponent} from "./imports/fileupload/fileupload.component";
import {NdmsRouteResolverGuard} from "../../shared/core/services/ndms-route-resolver.guard";
import {PatientRegistrationService} from "./patients/patient-registration/shared/services/patient-registration.service";
import { NdmsAuthenticationGuard } from "../../../ndms/app/shared/core-ndms/services/ndms-authentication.guard";

import { JpatsPolicyPermissionsService } from './shared/core-jpats/services/jpats-policy-permissions.service';
import { JpatsPolicyPermissionsGuard } from './shared/core-jpats/services/jpats-policy-permissions.guard';

const routes: Routes = [
  {
    path: 'jpats',
    redirectTo: 'jpats/patients',
    resolve: {
      response: NdmsAuthenticationGuard
    },
  },
  {
    path: 'jpats/home',
    component: PatientsHomeComponent

  },

  { path: 'jpats/unauthorized', component: UnauthorizedComponent },

  {
    path:'jpats/login/authorized',
    component: AuthorizedComponent,

  },
  {
    path:'jpats/logout',
    component: LoggedoutComponent
  },
  {
    path: 'jpats/patients',
    loadChildren: './patients/patients.module#PatientsModule',
    data: {
      breadcrumbs: 'Patients',
      resolvePermissions: JpatsPolicyPermissionsService.PermissionSets.Core
    },
    resolve: {
      response: NdmsAuthenticationGuard,
      policies: JpatsPolicyPermissionsGuard
    }
  },
  {
    path: 'jpats/help',
    loadChildren: './help/help.module#HelpModule',
    data: {
      breadcrumbs: 'Help',
      resolvePermissions: JpatsPolicyPermissionsService.PermissionSets.Core
    },
    resolve: {
      response: NdmsAuthenticationGuard,
      policies: JpatsPolicyPermissionsGuard
    }
  },
  {
    path: 'jpats/manifest',
    loadChildren: './manifest/manifest.module#ManifestModule',
    data: {
      breadcrumbs: 'Manifest',
      resolvePermissions: JpatsPolicyPermissionsService.PermissionSets.Core
    },
    resolve: {
      response: NdmsAuthenticationGuard,
      policies: JpatsPolicyPermissionsGuard
    }
  },
  {
    path:'jpats/import',
    component: FileuploadComponent,
    resolve: {
      response: NdmsRouteResolverGuard,
      policies: JpatsPolicyPermissionsGuard
    },
    data: {
      service: PatientRegistrationService,
      breadcrumbs: '',
      resolvePermissions: JpatsPolicyPermissionsService.PermissionSets.Core
    }
  },
  {
    path: 'jpats/operation',
    loadChildren: './operation/operation.module#OperationModule',
    data: {
      breadcrumbs: 'Operation',
      resolvePermissions: JpatsPolicyPermissionsService.PermissionSets.Core
    },
    resolve: {
      response: NdmsAuthenticationGuard,
      policies: JpatsPolicyPermissionsGuard
    }
  },
  {
    path: 'jpats/system-management',
    loadChildren: './system-management/system-management.module#SystemManagementModule',
    data: {
      breadcrumbs: 'System Settings',
      resolvePermissions: JpatsPolicyPermissionsService.PermissionSets.Core
    },
    resolve: {
      response: NdmsAuthenticationGuard,
      policies: JpatsPolicyPermissionsGuard
    }
  },
  {
    path: 'jpats/dashboard',
    loadChildren: '../../jpats/app/dashboard/dashboard.module#DashboardModule',
    data: {
      breadcrumbs: 'Dashboard',
      resolvePermissions: JpatsPolicyPermissionsService.PermissionSets.Core
    },
    resolve: {
      response: NdmsAuthenticationGuard,
      policies: JpatsPolicyPermissionsGuard
    }
  },
  {
    path: 'jpats/reports',
    loadChildren: './reports/reports.module#ReportsModule',
    data: {
      breadcrumbs: 'Reports',
      resolvePermissions: JpatsPolicyPermissionsService.PermissionSets.Core
    },
    resolve: {
      response: NdmsAuthenticationGuard,
      policies: JpatsPolicyPermissionsGuard
    }
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    McBreadcrumbsModule.forRoot()
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(private router: Router) {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
  }
}
